import React from 'react';

export const FolderSvg = () => (
  <svg width="223" height="217" viewBox="0 0 223 217" fill="none">
    <path
      d="M56.2504 216.74C52.6842 216.74 49.9052 213.647 50.2844 210.101L55.9589 157.045C56.2851 153.995 58.8582 151.683 61.9249 151.683L150.051 151.683C153.617 151.683 156.396 154.775 156.017 158.321L150.342 211.378C150.016 214.427 147.443 216.74 144.376 216.74L56.2504 216.74Z"
      fill="#9A9CA1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.6629 158.485L136.789 158.485C139.827 158.485 142.386 160.756 142.747 163.773L148.271 210.028C148.698 213.598 145.909 216.74 142.314 216.74L54.2046 216.74C51.1662 216.74 48.6074 214.468 48.247 211.451L42.7223 165.196C42.6838 164.874 42.6715 164.555 42.6837 164.242L42.3316 161.144C41.9271 157.584 44.7112 154.466 48.2932 154.466L54.2349 154.466L74.9991 154.466C77.5791 154.466 79.8333 156.108 80.6629 158.485Z"
      fill="#2C7CD6"
    />
    <g opacity="0.4" filter="url(#filter0_d)">
      <rect x="111.152" y="71.6667" width="70.9709" height="24.863" fill="#75787A" />
      <rect x="111.152" y="96.5295" width="70.9709" height="21.7551" fill="#EFF2F5" />
      <rect x="113.558" y="99.6376" width="18.6449" height="3.72945" fill="#979797" />
      <rect x="137.616" y="99.6376" width="19.2463" height="3.72945" fill="#979797" />
      <rect x="161.674" y="99.6376" width="18.6449" height="3.72945" fill="#979797" />
      <rect x="113.558" y="105.232" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="113.558" y="108.34" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="113.558" y="111.447" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="137.616" y="105.232" width="19.2463" height="1.86473" fill="#C4C4C4" />
      <rect x="137.616" y="108.34" width="19.2463" height="1.86473" fill="#C4C4C4" />
      <rect x="137.616" y="111.447" width="19.2463" height="1.86473" fill="#C4C4C4" />
      <rect x="161.674" y="105.232" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="161.674" y="108.34" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="161.674" y="111.447" width="18.6449" height="1.86473" fill="#C4C4C4" />
      <rect x="113.407" y="83.3212" width="36.0869" height="5.59418" fill="white" />
    </g>
    <g opacity="0.2" filter="url(#filter1_d)">
      <rect x="4" y="31.3107" width="105.761" height="37.0508" fill="#75787A" />
      <rect x="4" y="68.3615" width="105.761" height="32.4194" fill="#EFF2F5" />
      <rect x="7.58496" y="72.993" width="27.7846" height="5.55761" fill="#979797" />
      <rect x="43.4363" y="72.993" width="28.6808" height="5.55761" fill="#979797" />
      <rect x="79.2871" y="72.993" width="27.7846" height="5.55761" fill="#979797" />
      <rect x="7.58496" y="81.3295" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="7.58496" y="85.9609" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="7.58496" y="90.5914" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="43.4363" y="81.3295" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="43.4363" y="85.9609" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="43.4363" y="90.5914" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="79.2871" y="81.3295" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="79.2871" y="85.9609" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="79.2871" y="90.5914" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="7.36096" y="48.6782" width="53.7766" height="8.33642" fill="white" />
    </g>
    <g opacity="0.1" filter="url(#filter2_d)">
      <rect x="113.24" width="105.761" height="37.0508" fill="#75787A" />
      <rect x="113.24" y="37.0508" width="105.761" height="32.4194" fill="#EFF2F5" />
      <rect x="116.824" y="41.6823" width="27.7846" height="5.55761" fill="#979797" />
      <rect x="152.676" y="41.6823" width="28.6808" height="5.55761" fill="#979797" />
      <rect x="188.527" y="41.6823" width="27.7846" height="5.55761" fill="#979797" />
      <rect x="116.824" y="50.0188" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="116.824" y="54.6502" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="116.824" y="59.2807" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="152.676" y="50.0188" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="152.676" y="54.6502" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="152.676" y="59.2807" width="28.6808" height="2.77881" fill="#C4C4C4" />
      <rect x="188.527" y="50.0188" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="188.527" y="54.6502" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="188.527" y="59.2807" width="27.7846" height="2.77881" fill="#C4C4C4" />
      <rect x="116.6" y="17.3675" width="53.7766" height="8.33642" fill="white" />
    </g>
    <g opacity="0.6" filter="url(#filter3_d)">
      <rect x="48.5308" y="98.8026" width="50.1964" height="18.5544" fill="#75787A" />
      <rect x="48.5308" y="117.357" width="50.1964" height="16.2351" fill="#EFF2F5" />
      <rect x="50.2324" y="119.676" width="13.1872" height="2.78316" fill="#979797" />
      <rect x="67.248" y="119.676" width="13.6126" height="2.78316" fill="#979797" />
      <rect x="84.2639" y="119.676" width="13.1872" height="2.78316" fill="#979797" />
      <rect x="50.2324" y="123.851" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="50.2324" y="126.17" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="50.2324" y="128.49" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="67.248" y="123.851" width="13.6126" height="1.39158" fill="#C4C4C4" />
      <rect x="67.248" y="126.17" width="13.6126" height="1.39158" fill="#C4C4C4" />
      <rect x="67.248" y="128.49" width="13.6126" height="1.39158" fill="#C4C4C4" />
      <rect x="84.2639" y="123.851" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="84.2639" y="126.17" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="84.2639" y="128.49" width="13.1872" height="1.39158" fill="#C4C4C4" />
      <rect x="50.2324" y="107.616" width="25.5236" height="4.17475" fill="white" />
    </g>
    <g filter="url(#filter4_d)">
      <rect x="86.1036" y="123.155" width="49.2622" height="16.699" fill="#75787A" />
      <rect x="86.1036" y="139.854" width="49.2622" height="14.6117" fill="#EFF2F5" />
      <rect x="87.7736" y="141.942" width="12.9418" height="2.50486" fill="#979797" />
      <rect x="104.473" y="141.942" width="13.3592" height="2.50486" fill="#979797" />
      <rect x="121.172" y="141.942" width="12.9418" height="2.50486" fill="#979797" />
      <rect x="87.7736" y="145.699" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="87.7736" y="147.786" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="87.7736" y="149.874" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="104.473" y="145.699" width="13.3592" height="1.25243" fill="#C4C4C4" />
      <rect x="104.473" y="147.786" width="13.3592" height="1.25243" fill="#C4C4C4" />
      <rect x="104.473" y="149.874" width="13.3592" height="1.25243" fill="#C4C4C4" />
      <rect x="121.172" y="145.699" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="121.172" y="147.786" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="121.172" y="149.874" width="12.9418" height="1.25243" fill="#C4C4C4" />
      <rect x="87.7736" y="131.087" width="25.0486" height="3.75728" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="107.152"
        y="71.6667"
        width="78.9709"
        height="54.618"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter1_d"
        x="0"
        y="31.3107"
        width="113.761"
        height="77.4702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter2_d"
        x="109.24"
        y="0"
        width="113.761"
        height="77.4702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter3_d"
        x="44.5308"
        y="98.8026"
        width="58.1964"
        height="42.7894"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter4_d"
        x="82.1036"
        y="123.155"
        width="57.2622"
        height="39.3107"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
